import React, {memo, ReactNode, useState} from 'react'
import {Container, Divider, Icon} from 'ac-brand-ui'
import {FeedbackFormContainer} from 'ac-brand-share-client'
import {WhiteLogoSvg} from './WhiteLogoSvg'
import {CONFIG} from '../../constants'
import {mdiCookie} from '@mdi/js'
import {AuthSubsystemIdEnum, LegalDocumentUrl} from 'ac-brand-share'

interface FooterProps {}

const Footer: React.FC<FooterProps> = memo(({}): React.ReactElement => {
  const [isOpenFeedbackForm, setIsOpenFeedbackForm] = useState<boolean>(false)

  const renderFeedbackForm = (): ReactNode => {
    if (isOpenFeedbackForm) {
      return (
        <FeedbackFormContainer
          authSubsystem={AuthSubsystemIdEnum.CRM_EXECUTOR}
          onClose={() => {
            setIsOpenFeedbackForm(false)
          }}
        />
      )
    }
  }

  const renderInfo = (): React.ReactNode => {
    return (
      <div className={'footer-content-info'}>
        {<div className={'footer-content-info-logo'}>{WhiteLogoSvg}</div>}
        {/*<div className={'footer-content-info-telegram'}>*/}
        {/*  <span className={'footer-content-info-telegram-text'}>Мы в соцсетях</span>*/}
        {/*  <a className={'footer-content-info-telegram-icon'} href={'https://t.me/CRMPatentOfficial'}>*/}
        {/*    {SocialTelegramSvg}*/}
        {/*  </a>*/}
        {/*</div>*/}
      </div>
    )
  }

  const renderLinks = (): React.ReactNode => {
    return (
      <div className={'footer-content-links'}>
        <a href={CONFIG.crmSiteWeb + '/legal'} className={'footer-content-link'}>
          Юридические документы
        </a>{' '}
        <span className={'footer-content-link l-divider'}> | </span>
        <p
          className={'footer-content-link cursor-pointer'}
          onClick={() => {
            setIsOpenFeedbackForm(true)
          }}>
          Написать в поддержку
        </p>
      </div>
    )
  }
  const renderCopyright = (): React.ReactNode => {
    return (
      <div className={'w-100 d-flex justify-content-between align-items-center flex-wrap'}>
        <div className={'footer-content-copyright'}>
          <p className={'mb-0'}>© {new Date().getFullYear()} ・ООО «ИНТЕЛЛЕБОКС»</p>
        </div>
      </div>
    )
  }

  const renderOrganization = (): React.ReactNode => {
    return (
      <div className={'footer-organization-info caption mb-x6'}>
        ИНН 2310232380 Юридический адрес: 350002, КРАСНОДАРСКИЙ КРАЙ, Г.О. ГОРОД КРАСНОДАР, Г КРАСНОДАР, УЛ СЕВЕРНАЯ, Д.
        405, ЭТАЖ 2, ОФИС 201
      </div>
    )
  }

  const renderOkved = (): React.ReactNode => {
    return (
      <div className={'footer-content-date'}>
        <div className={'footer-organization-okved mb-x6'}>
          <p className={'mb-0'}>Основной ОКВЭД:</p>
          <p className={'mb-0'}>62.01 Разработка компьютерного программного обеспечения</p>
          <p className={'mb-0'}>Перечень видов деятельности в области информационных технологий:</p>
          <p className={'mb-0'}>
            2.01 Реализация программ для ЭВМ, баз данных (включая их обновления и изменения), средств защиты информации,
            в том числе путем отчуждения прав, предоставления прав (лицензирования), предоставления удаленного доступа
            посредством информационно-телекоммуникационных сетей, включая информационно-телекоммуникационную сеть
            «Интернет», предоставление удалённых вычислительных мощностей, эмулирующих физическое оборудование,
            копирования, оптовой и розничной продажи экземпляров программ для ЭВМ, баз данных, издание сборников
            программ для ЭВМ и баз данных, предоставления экземпляров программ для ЭВМ, баз данных в лизинг, аренду
            (прокат).
          </p>
          <p className={'mb-0'}>
            63.11.1 Деятельность по созданию и использованию баз данных и информационных ресурсов.
          </p>
        </div>
      </div>
    )
  }
  const renderCookie = (): React.ReactNode => {
    return (
      <div className={'footer-organization-cookie'}>
        <Icon path={mdiCookie} size={'16px'} className={'mr-x1'} />
        Используем cookies для&nbsp;корректной работы сайта, персонализации пользователей и&nbsp;других целей,
        предусмотренных&nbsp;
        <a href={LegalDocumentUrl.PRIVACY}>политикой конфиденциальности</a>
      </div>
    )
  }
  return (
    <>
      <div className={'footer-site'}>
        <Container>
          <div className={'footer-content'}>
            <div className={'footer-logo-and-links-container'}>
              {renderInfo()}
              {renderLinks()}
            </div>
            <Divider className={'footer-content-divider'} />
            <div className={'mb-x6'}>
              {renderCopyright()}
              {renderOrganization()}
              {renderOkved()}
              {renderCookie()}
            </div>
          </div>
        </Container>
      </div>
      {renderFeedbackForm()}
    </>
  )
})

export {Footer}
